document.addEventListener("DOMContentLoaded", async function () {
	const form = document.querySelector(".js-custom-made-form");
	if (!form) return;

	// Error messages (customize as needed)
	const errorMsgs = FoxTheme.contactStrings;

	// Get shadow form ID from data attribute
	const shadowFormId = form.getAttribute("data-shadow-form-id");

	function hideShadowForm() {
		document.querySelectorAll(`div[data-forms-id="forms-root-${shadowFormId}"]`).forEach((div) => {
			if (div.closest(".section-app")) {
				div.closest(".section-app").style.display = "none";
			} else {
				div.style.display = "none";
			}
		});
	}
	hideShadowForm();

	// Utility to show error
	function showError(field, msg) {
		removeError(field);
		if (field.tagName === "SELECT") {
			let selectWrapper = field.closest(".select");
			let parent = selectWrapper ? selectWrapper.parentNode : field.parentNode;
			let span = parent.querySelector(".js-error-msg-select");
			if (!span) {
				span = document.createElement("span");
				span.className = "form-message form-message--error js-error-msg-select";
				span.style.color = "#E8083E";
				span.style.display = "block";
				span.style.marginTop = "0.2em";
				parent.appendChild(span);
			}
			span.innerText = msg;
			field.setAttribute("aria-invalid", "true");
		} else {
			let span = field.parentNode.querySelector(".js-error-msg");
			if (!span) {
				span = document.createElement("span");
				span.className = "form-message form-message--error js-error-msg";
				span.style.color = "#E8083E";
				span.style.display = "block";
				span.style.marginTop = "0.2em";
				field.parentNode.appendChild(span);
			}
			span.innerText = msg;
			field.setAttribute("aria-invalid", "true");
		}
	}
	function removeError(field) {
		field.removeAttribute("aria-invalid");
		if (field.tagName === "SELECT") {
			let selectWrapper = field.closest(".select");
			let parent = selectWrapper ? selectWrapper.parentNode : field.parentNode;
			const err = parent.querySelector(".js-error-msg-select");
			if (err) err.remove();
		}
		const err = field.parentNode.querySelector(".js-error-msg");
		if (err) err.remove();
	}

	// Main fields
	const mainFields = {
		firstName: form.querySelector('[name="custom[first_name]"]'),
		lastName: form.querySelector('[name="custom[last_name]"]'),
		email: form.querySelector('[name="custom[email]"]'),
		confirmEmail: form.querySelector('[name="custom[confirm_email]"]'),
		message: form.querySelector('[name="custom[custom_request_message]"]'),
	};

	// Track if submit has been attempted
	let submitAttempted = false;

	// Validate a single field
	function validateField(field) {
		if (!field.required) {
			removeError(field);
			return true;
		}
		// Email format validation
		if ((field === mainFields.email || field === mainFields.confirmEmail) && field.value.trim()) {
			const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
			if (!emailPattern.test(field.value.trim())) {
				showError(field, errorMsgs.emailFormat || "Format d'email invalide");
				return false;
			}
		}
		if (field.tagName === "SELECT") {
			if (!field.value || field.options[field.selectedIndex].disabled) {
				removeError(field);
				return true;
			}
		}
		if (!field.value.trim()) {
			if (field === mainFields.firstName) showError(field, errorMsgs.firstName);
			else if (field === mainFields.lastName) showError(field, errorMsgs.lastName);
			else if (field === mainFields.email) showError(field, errorMsgs.email);
			else if (field === mainFields.confirmEmail) showError(field, errorMsgs.confirmEmail);
			else if (field === mainFields.message) showError(field, errorMsgs.message);
			return false;
		}
		removeError(field);
		return true;
	}

	// Validate emails match, prioritize format, show errors only on submit
	function validateEmailsMatch() {
		const email = mainFields.email.value.trim();
		const confirm = mainFields.confirmEmail.value.trim();
		let valid = true;
		const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
		let emailValid = true;
		let confirmValid = true;

		if (!email) {
			showError(mainFields.email, errorMsgs.email);
			valid = false;
			emailValid = false;
		} else if (!emailPattern.test(email)) {
			showError(mainFields.email, errorMsgs.emailFormat || "Format d'email invalide");
			valid = false;
			emailValid = false;
		}

		if (!confirm) {
			showError(mainFields.confirmEmail, errorMsgs.confirmEmail);
			valid = false;
			confirmValid = false;
		} else if (!emailPattern.test(confirm)) {
			showError(mainFields.confirmEmail, errorMsgs.emailFormat || "Format d'email invalide");
			valid = false;
			confirmValid = false;
		}

		if (emailValid && confirmValid) {
			if (email !== confirm) {
				if (submitAttempted) {
					showError(mainFields.email, errorMsgs.emailMatch);
					showError(mainFields.confirmEmail, errorMsgs.emailMatch);
				} else {
					removeError(mainFields.email);
					removeError(mainFields.confirmEmail);
				}
				valid = false;
			} else {
				removeError(mainFields.email);
				removeError(mainFields.confirmEmail);
			}
		}
		return valid;
	}

	// Attach validation events (only remove error on input, never show error unless submitAttempted)
	Object.values(mainFields).forEach((field) => {
		if (!field) return;
		field.addEventListener("input", () => {
			if (submitAttempted) {
				validateField(field);
				if (field === mainFields.email || field === mainFields.confirmEmail) validateEmailsMatch();
			} else {
				removeError(field);
			}
		});
	});

	const FormHelper = await ShopifyFormHelper.waitTillShopifyFormIsReady(document.body, (formSection) => {
		return formSection.querySelector("#app-embed");
	});

	// On submit: validate all
	const submitBtn = form.querySelector(".js-custom-made-submit");
	if (submitBtn === null) {
		return;
	}

	submitBtn.addEventListener("click", function (e) {
		e.preventDefault();
		submitAttempted = true;
		let valid = true;
		form.querySelectorAll("input[required], textarea[required], select[required]").forEach((field) => {
			if (!validateField(field)) valid = false;
		});
		if (!validateEmailsMatch()) valid = false;
		if (!valid) return;

		// Inject values into shadow form (for embedded apps)
		const SEPARATOR = "|||";
		const fieldNodes = form.querySelectorAll("input, textarea, select");
		let contentArr = [];
		let emailValue = "";
		// Get the data-lang attribute from the form wrapper
		const langValue = document.querySelector(".contact-form__wrapper")?.getAttribute("data-lang") || "";
		// Add language as a field in the content array
		if (langValue) {
			contentArr.push("lang: " + langValue);
		}
		fieldNodes.forEach((node) => {
			if (!node.name || node.offsetParent === null) return;
			if (node.name === "custom[email]") {
				emailValue = node.value;
				return;
			}
			if (node.name === "custom[confirm_email]") return;
			let label = "";
			// const labelEl = form.querySelector('label[for="' + node.id + '"]');
			// label = labelEl ? labelEl.innerText.trim() : node.name.replace(/^custom\[|\]$/g, "").replace(/_/g, " ");
			label = node.name.replace(/^custom\[|\]$/g, "");
			let value =
				node.type === "checkbox" || node.type === "radio"
					? node.checked
						? node.value
						: ""
					: node.tagName.toLowerCase() === "select" && !node.multiple
						? node.options[node.selectedIndex]?.text || ""
						: node.tagName.toLowerCase() === "select" && node.multiple
							? Array.from(node.selectedOptions)
									.map((opt) => opt.text)
									.join(", ")
							: node.value;
			if (value) contentArr.push(label + ": " + value);
		});
		const shadowEmail = FormHelper.querySelector("#email");
		if (shadowEmail && emailValue) {
			shadowEmail.value = emailValue;
			shadowEmail.dispatchEvent(new Event("input", { bubbles: true }));
		}
		const shadowContent = FormHelper.querySelector("#custom\\#content");
		if (shadowContent) {
			shadowContent.value = contentArr.join(SEPARATOR);
			shadowContent.dispatchEvent(new Event("input", { bubbles: true }));
		}

		FormHelper.submitForm();
	});

	// After successful submit, reload with ?custom_posted=1 to show success message
	FormHelper.on("success", () => {
		const url = new URL(window.location.href);
		url.searchParams.set("custom_posted", true);
		window.location.href = url.toString();
	});

	// On page load, show success message if param is present
	const params = new URLSearchParams(window.location.search);
	if (params.get("custom_posted") == "true") {
		const formStatus = document.querySelector(".form-status-list");
		if (formStatus) {
			formStatus.style.display = "block";
			formStatus.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	}
});
